import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CanComponentDeactivateGuard } from '@qwyk/core';
import { CanCreateOrUpdatePortalUsersGuard } from '@qwyk/hub/authentication';

import {
    CustomerUserViewComponent,
    CustomerUsersListComponent,
} from './components';
import { MagayaUserGuard } from './guards/magaya-user.guard';
import { CustomerUserExistsGuard } from './guards/customer-user-exists.guard';
import { HubAdministrationCustomerUsersWithoutRoutingModule } from './hub-administration-customer-users-without-routing.module';

@NgModule({
    imports: [
        CommonModule,
        HubAdministrationCustomerUsersWithoutRoutingModule,
        RouterModule.forChild([
            {
                path: '',
                pathMatch: 'full',
                component: CustomerUsersListComponent,
            },
            {
                path: 'new',
                component: CustomerUserViewComponent,
                canActivate: [CanCreateOrUpdatePortalUsersGuard],
                canDeactivate: [CanComponentDeactivateGuard],
            },
            {
                path: ':id',
                component: CustomerUserViewComponent,
                canActivate: [CustomerUserExistsGuard, MagayaUserGuard],
                canDeactivate: [CanComponentDeactivateGuard],
            },
        ]),
    ],
})
export class HubAdministrationCustomerUsersModule {}
